import React, {Component, Fragment} from "react";
import {getData, postData} from "../../api/doLogin";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";
import {formsUpdater, getFormFieldValue} from "../Applications/shared/shared";
import {ReviewsOptions} from "./ReviewConstants";
import {isNumber} from "../../util/numberhelpers";
import {SafeZoomImage} from "../../components/Shared/SafeZoomImage";
import {EventClient} from "../../util/eventClient";
import {formatDate} from "../../util/datehelpers";
import {hasPermission, RequiredPermission} from "../../api/permissionHelper";
import {ReplaceableImageWrapper} from "../../components/Shared/ReplaceableImageWrapper";
import {getGlobalState} from "../../constants/GlobalStore";

export default class ReviewEntryEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {dated: formatDate(new Date())},
      users: [],
      working: false
    }
  }

  componentDidMount() {
    EventClient.on(this.props.saveEvent, () => this.saveExternal(), this.props.eventName);
    this.getDBConstants();
  }

  componentWillUnmount() {
    EventClient.off(this.props.saveEvent, () => this.saveExternal(), this.props.eventName);
  }

  saveExternal() {
    this.save((resp) => {
      if (this.props.onSave) {
        this.props.onSave(resp);
      }
    })
  }

  getDBConstants() {
    const self = this;
    getData("reviews/get/" + this.props.review || 0, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          const stateData = {}
          if (hasPermission(RequiredPermission.ReviewViewAddAll)) {
            stateData['users'] = data.data.users;
          }
          if (isNumber(this.props.review)) {
            stateData['formData'] = data.data.review;
          }
          if (Object.keys(stateData).length > 0) self.setState(stateData);
        }
      })
      .catch((error) => {
        console.log(error);
      })
  }

  save(cb) {
    const self = this;
    const payload = {
      formData: {
        ...this.state.formData,
      }, action: isNumber(self.props.review) ? "update" : "add"
    };
    postData("reviews/save", payload)
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          if (!isNumber(self.props.review)) {
            cb({...this.state.formData, id: data.data.id});
          } else {
            cb({...this.state.formData});
          }
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  render() {
    return (
      <Fragment>
        <Row>
          <Col xs="12" md="6">
            <FormGroup>
              <Label for="customer">Customer</Label>
              <Input
                type="text"
                id="customer"
                value={getFormFieldValue(this.state.formData['customer'])}
                onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
              />
            </FormGroup>
          </Col>
          <Col xs="12" md="6">
            <FormGroup>
              <Label for="url">Review Site:</Label>
              <Input type="select" id="url" placeholder=""
                     value={getFormFieldValue(this.state.formData['url'])}
                     onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
              >
                <option value={""} disabled>Please Select...</option>
                {(ReviewsOptions || []).map((val, i) => {
                  return <option key={i} value={val.value}>{val.display}</option>
                })}
              </Input>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs="12" md="6">
            <FormGroup>
              <Label for="dated">Dated</Label>
              <Input
                type="date"
                id="dated"
                placeholder="date"
                value={getFormFieldValue(this.state.formData['dated'])}
                onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => {
                  // this.dateValidator('start');
                })}
              />
            </FormGroup>
          </Col>

          {hasPermission(RequiredPermission.ReviewViewAddAll) && (
            <Col xs="12" md="6">
              <FormGroup>
                <Label for="uid">Submitted User:</Label>
                <Input type="select" id="uid" placeholder=""
                       value={getFormFieldValue(this.state.formData['uid'])}
                       onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                >
                  <option value={""} disabled>Please Select...</option>
                  {(this.state.users || [])
                    .filter((user) => user.visible === 1 || user.id === this.state.formData['uid'])
                    .map((val, i) => {
                      return <option key={i} value={val.id}>{`${val.fname} ${val.lname}`}</option>
                    })}
                </Input>
              </FormGroup>
            </Col>
          )}

        </Row>
        {isNumber(this.props.review) && (
          <Row>
            <Col xs={12}>
              <div style={{marginLeft: "auto", marginRight: "auto", width: "fit-content"}}>
                <ReplaceableImageWrapper
                  canReplace={hasPermission(RequiredPermission.ReviewViewAddAll) || this.state.formData.uid === getGlobalState('loginID')}
                  uploadURL={`reviews/file/${this.props.review}`}
                  acceptedMimes={["image/jpeg", "image/png", "image/gif"]}
                  appendFormData={[{name: "action", value: "UploadFile"}]}
                  limit={1}
                  onUpload={() => this.setState({working: true})}
                  onComplete={() => this.setState({working: false})}
                  onReplace={(url, cb) => this.setState({
                    formData: {
                      ...this.state.formData,
                      s3url: `${url[0].s3url}`,
                      s3key: `${url[0].s3key}`,
                    }
                  })
                  }
                >
                  <SafeZoomImage src={this.state.formData.s3url || ""} width={"50%"} height={"auto"}/>
                </ReplaceableImageWrapper>
              </div>
            </Col>
          </Row>
        )}
      </Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Reviews/ReviewEntryEditor.js